var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SearchableDropdown",
    _vm._b(
      {
        staticClass: "form__searchable-dropdown",
        attrs: { config: _vm.publisherValueConfig },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function({ prefix, numbersOnly, search }) {
              return [
                _c(
                  "input",
                  _vm._g(
                    _vm._b(
                      {
                        directives: [
                          {
                            name: "prefix",
                            rawName: "v-prefix",
                            value: prefix,
                            expression: "prefix"
                          },
                          {
                            name: "numbers-only",
                            rawName: "v-numbers-only",
                            value: numbersOnly,
                            expression: "numbersOnly"
                          }
                        ],
                        staticClass: "form-control vs__search--custom m-b-0",
                        class: { closed: !search.attributes["aria-expanded"] }
                      },
                      "input",
                      search.attributes,
                      false
                    ),
                    search.events
                  )
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.computedValue,
          callback: function($$v) {
            _vm.computedValue = $$v
          },
          expression: "computedValue"
        }
      },
      "SearchableDropdown",
      { ..._vm.$props, ..._vm.$attrs },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }